import React, { useEffect, useState } from 'react';
import { Modal } from 'bootstrap';

//Style
import style from "../../../Style/Component/portfolio.module.scss";

//Custom components
import { TextButton } from '../../../Components/Buttons';
import { OrderCard } from '../../../Components/Card';
import { ActiveSipModal, OrderHistoryModal } from '../../../Components/Modal';


const FundDetail = (props) => {


    const [toggleXIRR, setToggleXIRR] = useState(true);
    const [toggleValue, setToggleValue] = useState(false);

    const [showOrderHistoryModal, setShowOrderHistoryModal] = useState(false);
    const [showActiveSipModal, setShowActiveSipModal] = useState(false);

    useEffect(() => {
        if (showOrderHistoryModal) {
            var modal = new Modal(document.getElementById("order-history-modal"));
            modal.show();
        }
    }, [showOrderHistoryModal]);


    useEffect(() => {
        if (showActiveSipModal === true) {
            var modal = new Modal(document.getElementById("active-sip-modal"));
            modal.show();
        }
    }, [showActiveSipModal]);

    // handle toggle 
    const _handleToggleXIRR = () => {
        setToggleXIRR(prev => !prev);
    };

    // handle toggle 
    const _handleToggle = () => {
        setToggleValue(prev => !prev);
    };


    return (
        <div className={style.e_portfolio_wrapper}>


            <div className='row pt-1'>
                <div className='col-6 d-flex flex-column gap-4'>
                    <div className='d-flex align-items-center gap-3 e-bg-magnolia p-3 mb-2 border-radius-8'>
                        <div className='e-border-0-5px-bright-gray-dark border-radius-6 e-bg-white d-flex p-1'>
                            <img src={props.data?.fund_image || props.data.image}
                                draggable={false}
                                className='border-radius-6 '
                                width={38}
                                height={38}
                                alt='fund' />
                        </div>

                        <h6 className='mb-0 e-text-dark-gray e-alt-font e-font-16 e-font-weight-600 line-height-22px'>
                            {props.data.fund_name}
                        </h6>
                    </div>

                    <div className="e-border-1px-taupe-gray e-bg-  border-radius-16 py-3 pe-3">
                        <div className="d-flex align-items-center justify-content-between margin-12px-bottom">
                            <p className='ribbon-bg e-text-dark-gray e-alt-font e-font-12 e-font-weight-600 mb-0'>
                                {props.detailType === "instasave" ? "Insta Save" : props.detailType === "goldmaxx" ? "Gold Maxx" : ""}
                            </p>

                            <div className='d-flex gap-1 align-items-center justify-content-end  mb-xxl-0   cursor-pointer'
                                onClick={_handleToggleXIRR}>
                                <p className="mb-0 w-max-content e-text-princeton-orange e-alt-font e-font-14 e-font-weight-600 line-height-16px">
                                    {toggleXIRR ? "XIRR" : "Absolute"} (%)
                                </p>
                                <img src={require("../../../Assets/Image/Others/arrow-toggle.svg").default}
                                    alt='arrow toggle' />
                            </div>
                        </div>

                        <div className="row flex-column gap-2 ps-3">
                            <div className='col'>
                                <p className='d-flex justify-content-between mb-0 e-text-arsenic e-alt-font e-font-12 e-font-weight-400 line-height-16px'>
                                    Current Value
                                    <span className='e-font-14 e-font-weight-600 e-text-dark-gray line-height-18px'>
                                        {props.data?.dashboard?.current_amount_text || props.data?.current_amount_text}
                                    </span>
                                </p>
                            </div>
                            <div className='col'>
                                <p className='d-flex justify-content-between mb-0 e-text-arsenic e-alt-font e-font-12 e-font-weight-400 line-height-16px'>
                                    Invested Amount
                                    <span className='e-font-14 e-font-weight-600 e-text-dark-gray line-height-18px'>
                                        {props.data?.dashboard?.invested_amount_text || props.data?.invested_amount_text}
                                    </span>
                                </p>
                            </div>

                            <div className='col'>
                                <div className='d-flex justify-content-between'>
                                    <p className='d-flex justify-content-between mb-0 e-text-arsenic e-alt-font e-font-12 e-font-weight-400 line-height-16px'>
                                        {toggleXIRR ? "XIRR Returns" : "Absolute Returns"}
                                    </p>

                                    {props.detailType === 'self-managed' ?
                                        <p className={`${props.data?.returns_amount > 0 ? "e-text-success" : props.data?.returns_amount < 0 ? "e-text-carmine-pink" : "e-text-dark-gray"} mb-0 e-alt-font e-font-18 e-font-weight-600 line-height-20px`}>
                                            {props.data?.returns_amount_text || "-"}
                                            {
                                                toggleXIRR ?
                                                    <span className={`${props.data.xirr > 0 ? "e-text-success" : props.data.xirr < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"} e-font-weight-600 e-font-16`}>({props.data.xirr_text})</span>
                                                    :
                                                    <span className={`${props.data.returns_percentage > 0 ? "e-text-success" : props.data.returns_percentage < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"} e-font-weight-600 e-font-16`}>({props.data.returns_percentage_text})</span>
                                            }
                                        </p>
                                        :
                                        <p className={`${props.data?.dashboard?.returns_amount > 0 ? "e-text-success" : props.data?.dashboard?.returns_amount < 0 ? "e-text-carmine-pink" : "e-text-dark-gray"} mb-0 e-alt-font e-font-18 e-font-weight-600 line-height-20px`}>
                                            {props.data?.dashboard?.returns_amount_text || "-"}
                                            {
                                                toggleXIRR ?
                                                    <span className={`${props.data.dashboard.xirr > 0 ? "e-text-success" : props.data.dashboard.xirr < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"} e-font-weight-600 e-font-16`}>({props.data.dashboard.xirr_text})</span>
                                                    :
                                                    <span className={`${props.data.dashboard.returns_percentage > 0 ? "e-text-success" : props.data.dashboard.returns_percentage < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"} e-font-weight-600 e-font-16`}>({props.data.dashboard.returns_percentage_text})</span>
                                            }
                                        </p>
                                    }
                                </div>
                            </div>

                            <div className="col">
                                <div className='d-flex justify-content-between'>
                                    <p className='d-flex justify-content-between mb-0 e-text-arsenic e-alt-font e-font-12 e-font-weight-400 line-height-16px'>
                                        1 Day Change
                                    </p>

                                    {props.detailType === 'self-managed' ?
                                        <p className={`${props.data?.one_day_returns > 0 ? "e-text-success" : props.data?.one_day_returns < 0 ? "e-text-carmine-pink" : "e-text-dark-gray"} mb-0 e-alt-font e-font-18 e-font-weight-600 line-height-20px`}>
                                            {props.data?.one_day_returns_text || "-"}
                                            <span className={` e-font-16 e-font-weight-600  line-height-18px`}>
                                                ({props.data?.one_day_returns_percentage_text || "-"})
                                            </span>
                                        </p>
                                        :
                                        <p className={`${props.data?.dashboard?.one_day_returns > 0 ? "e-text-success" : props.data?.dashboard?.one_day_returns < 0 ? "e-text-carmine-pink" : "e-text-dark-gray"} mb-0 e-alt-font e-font-18 e-font-weight-600 line-height-20px`}>
                                            {props.data?.dashboard?.one_day_returns_text || "-"}
                                            <span className={` e-font-16 e-font-weight-600  line-height-18px`}>
                                                ({props.data?.dashboard?.one_day_returns_percentage_text || "-"})
                                            </span>
                                        </p>
                                    }
                                </div>
                            </div>
                            <div className='col'>
                                <p className='d-flex justify-content-between mb-0 e-text-arsenic e-alt-font e-font-12 e-font-weight-400 line-height-16px'>
                                    Units
                                    <span className='e-font-14 e-font-weight-600 e-text-dark-gray line-height-18px'>
                                        {props.data?.dashboard?.units || props.data?.units}
                                    </span>
                                </p>
                            </div>
                            <div className='col'>
                                <p className='d-flex justify-content-between mb-0 e-text-arsenic e-alt-font e-font-12 e-font-weight-400 line-height-16px'>
                                    Avg. NAV
                                    <span className='e-font-14 e-font-weight-600 e-text-dark-gray line-height-18px'>
                                        {props.data?.dashboard?.avg_nav_text || props.data?.avg_nav_text}
                                    </span>
                                </p>
                            </div>
                            <div className='col'>
                                <div className='d-flex flex- gap-2 justify-content-between '>
                                    <p className='mb-0 e-text-arsenic e-alt-font e-font-12 e-font-weight-400 line-height-16px text-nowrap'>
                                        Folio Number
                                    </p>
                                    <div className='d-flex align-items-center flex-wrap justify-content-end'>
                                        {props.data.folio_numbers ?
                                            <>
                                                {props.data.folio_numbers.map((data, index) => (
                                                    <span key={index} className='e-font-14 e-font-weight-600 e-text-dark-gray line-height-18px'>
                                                        {data}{index !== props.data.folio_numbers.length - 1 && ","}
                                                    </span>
                                                ))}
                                            </>
                                            :
                                            <span className='e-font-14 e-font-weight-600 e-text-dark-gray line-height-18px'>
                                                -
                                            </span>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Overview */}
                    {props.data.sip_available &&
                        <div className='d-flex flex-column gap-2'>
                            {/* Overview */}
                            {Object.keys(props.activeSip).length !== 0 &&
                                <>
                                    {props.activeSip?.data?.sips.slice(0, 2).map((sip, index) => (
                                        <div key={index} className={`${style.e_detail_data_card_wrapper} e-bg-white border-radius-12 p-4`}>
                                            <div className='d-flex justify-content-between align-items-start position-relative'>
                                                <h6 className='mb-0 e-text-dim-black e-alt-font e-font-16 e-font-weight-600 line-height-22px'>
                                                    SIP Amount
                                                </h6>

                                                <p className='mb-0 e-text-blue-violet e-alt-font e-font-18 e-font-weight-600 line-height-22px'>
                                                    {sip?.amount_text || '-'}
                                                </p>

                                            </div>
                                        </div>
                                    ))}

                                    {props.activeSip?.data?.sips?.length > 2 &&
                                        <div className='text-end d-flex justify-content-end' >
                                            <TextButton name="View all"
                                                className="e-font-weight-600 e-font-16 text-decoration-underline text-center mx-auto"
                                                onClick={() => {
                                                    setShowActiveSipModal(true);
                                                }} />
                                        </div>
                                    }
                                </>
                            }
                        </div>
                    }
                </div>

                <div className='col-6'>
                    {props.historyLoader === false && props.orderHistory?.orders?.length !== 0 &&
                        <div className={`${style.e_detail_data_card_wrapper}  e-bg-white border-radius-12 p-4   `}>
                            <div className='d-flex flex-column row-gap-3 align-items-start position-relative'>
                                <h6 className='mb-1 e-text-custom-blue e-alt-font e-font-16 e-font-weight-600 line-height-22px'>
                                    Order History
                                </h6>

                                <div className="d-flex flex-column gap-3 w-100">
                                    {
                                        props.orderHistory.orders.slice(0, 5).map((item, index) => <OrderCard key={index} order={item} />)
                                    }
                                </div>

                            </div>

                            {props.orderHistory.orders.length > 4 &&
                                <div className='text-center pt-4 mt-2' >
                                    <TextButton name="View all order history"
                                        className="e-font-weight-600 e-font-16 text-decoration-underline text-center mx-auto"
                                        onClick={() => {
                                            setShowOrderHistoryModal(true);
                                            props.handleViewHistory();
                                        }} />
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>


            {showOrderHistoryModal &&
                <OrderHistoryModal
                    orderHistory={props.modalHistoryData.orders}
                    currentPage={props.modalHistoryData.current_page}
                    totalPage={props.modalHistoryData.total_page}
                    handleViewMore={props.handleViewMore}
                    modalHistoryLoader={props.modalHistoryLoader}
                    forcedLoader={props.forcedLoader}
                    handleClose={() => {
                        setTimeout(() => {
                            setShowOrderHistoryModal(false);
                            props.handleClose();
                        }, 200);
                    }} />
            }

            {showActiveSipModal === true &&
                <ActiveSipModal data={props.activeSip.data.sips}
                    handleClose={() => {
                        setTimeout(() => {
                            setShowActiveSipModal(false);
                        }, 200);
                    }} />
            }
        </div>
    )
}

export default FundDetail;
